module.exports = __webpack_public_path__ + "static/media/courses-icon-active.133a18f4.svg";